import { render, staticRenderFns } from "./category.vue?vue&type=template&id=500fa3cb&"
import script from "./category.js?vue&type=script&lang=js&"
export * from "./category.js?vue&type=script&lang=js&"
import style0 from "./category.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports